import { ErgonomicsProvider } from '../../contexts/ErgonomicsContext';
import { ErgonomicsDashboardContent } from './ergonomics-components/ErgonomicsDashboardContent';

export const ErgonomicsDashboard = () => {
  return (
    <ErgonomicsProvider>
      <ErgonomicsDashboardContent />
    </ErgonomicsProvider>
  );
};